export default __webpack_public_path__ + "static/media/paper-capture1.529146b4.jpg";